import { buttonClasses } from '@mui/material/Button';
import { listClasses } from '@mui/material/List';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { paperClasses } from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';
import { tablePaginationClasses } from '@mui/material/TablePagination';
//
import { paper } from '../../css';
// ----------------------------------------------------------------------
export function dataGrid(theme) {
    const paperStyles = paper({ theme, dropdown: true });
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderWidth: 1,
                    borderColor: alpha(theme.palette.grey[500], 0.24),
                    bordeRadius: theme.spacing(1.75),
                    '& .MuiDataGrid-sortButton': {
                        border: 'none !important',
                        padding: 0,
                        background: 'none',
                        boxShadow: 'none'
                    },
                    '& .MuiDataGrid-cell': {
                        border: 'none !important'
                    },
                    '& .MuiSvgIcon-root ': {
                        color: theme.palette.text.primary
                    },
                    '& .MuiDataGrid-cell:focus': {
                        outline: 'none',
                        border: 'none'
                    },
                    '& .MuiDataGrid-cell:focus-within': {
                        outline: 'none',
                        border: 'none'
                    },
                    '& .MuiDataGrid-cell--editing': {
                        outline: 'none',
                        border: 'none'
                    },
                    '& .MuiDataGrid-cell--focus': {
                        outline: 'none',
                        border: 'none'
                    },
                    '& .MuiDataGrid-overlay': {
                        color: theme.palette.text.primary
                    },
                    '& .MuiDataGrid-row': {
                        cursor: 'pointer',
                        borderRadius: 0
                    },
                    '& .MuiDataGrid-container--top': {
                        backgroundColor: theme.palette.common.white
                    },
                    '.MuiDataGrid-columnHeaderTitle': {
                        // fontWeight: '600 !important',
                        overflow: 'hidden',
                        fontWeight: '400',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: theme.palette.text.primary,
                        fontSize: '14px'
                    },
                    [`& .${tablePaginationClasses.root}`]: {
                        borderTop: 0
                    },
                    [`& .${tablePaginationClasses.toolbar}`]: {
                        height: 'auto',
                        minHeight: 40,
                        color: theme.palette.text.secondary
                    },
                    [`& .${tablePaginationClasses.actions}`]: {
                        button: {
                            cursor: 'pointer',
                            borderWidth: 1,
                            borderColor: alpha(theme.palette.action.selected, 0.16),
                            borderRadius: theme.spacing(1.5),
                            padding: theme.spacing(0.5, 1),
                            margin: theme.spacing(0, 0.5),
                            backgroundColor: 'transparent',
                            color: theme.palette.text.primary,
                            '&.Mui-selected': {
                                backgroundColor: '#FFFFFF',
                                color: theme.palette.primary.main,
                                borderColor: '#FFFFFF'
                            },
                            '&:hover': {
                                backgroundColor: alpha(theme.palette.primary.main, 0.08)
                            },
                            '&.Mui-disabled': {
                                border: 'none',
                                color: alpha(theme.palette.action.disabled, 0.8),
                                cursor: 'not-allowed'
                            }
                        }
                    },
                    '& .MuiDataGrid-withBorderColor': {
                        borderColor: 'transparent'
                    },
                    '--DataGrid-rowBorderColor': 'transparent',
                    '--DataGrid-containerBackground': 'transparent'
                },
                footerContainer: {
                    minHeight: 44
                },
                cell: {
                    borderBottom: '1px solid transparent ',
                    color: theme.palette.text.primary,
                    ...theme.typography.body2,
                    display: 'flex',
                    alignItems: 'center'
                },
                selectedRowCount: {
                    whiteSpace: 'nowrap'
                },
                columnSeparator: {
                    color: theme.palette.divider,
                    display: 'none'
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    borderBottom: `1px solid transparent`,
                    backgroundColor: theme.palette.background.neutral
                },
                paper: {
                    ...paperStyles,
                    padding: 0
                },
                menu: {
                    [`& .${paperClasses.root}`]: {
                        ...paperStyles
                    },
                    [`& .${listClasses.root}`]: {
                        padding: 0,
                        [`& .${listItemIconClasses.root}`]: {
                            minWidth: 0,
                            marginRight: theme.spacing(2)
                        }
                    }
                },
                columnHeaders: {
                    borderBottom: `1px solid transparent`,
                    borderLeft: 'none',
                    borderRight: 'none',
                    // Layered as an opaque gradient over a solid paper base - rather than a plain
                    // alpha() background - so scrolled row content can't show through the sticky header.
                    background: `linear-gradient(0deg, ${alpha(theme.palette.primary.main, 0.08)}, ${alpha(theme.palette.primary.main, 0.08)}), ${theme.palette.background.paper}`
                },
                panelHeader: {
                    padding: theme.spacing(2)
                },
                panelFooter: {
                    padding: theme.spacing(2),
                    justifyContent: 'flex-end',
                    borderTop: '1px solid transparent',
                    borderColor: 'transparent',
                    [`& .${buttonClasses.root}`]: {
                        '&:last-of-type': {
                            marginLeft: theme.spacing(1.5),
                            color: theme.palette.background.paper,
                            backgroundColor: theme.palette.text.primary
                        }
                    }
                },
                filterForm: {
                    padding: theme.spacing(2)
                },
                filterFormValueInput: {
                    marginLeft: theme.spacing(2)
                },
                filterFormColumnInput: {
                    marginLeft: theme.spacing(2)
                },
                filterFormOperatorInput: {
                    marginLeft: theme.spacing(2)
                }
            }
        }
    };
}
